var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"#3F3F3F","dark":""}},[_c('v-toolbar-title',[_vm._v("Customer Applications")]),_c('v-spacer')],1),_c('v-main',[_c('SnackBarService'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }